import React from "react";

export default function ChevronDownRounded({ className }) {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      x="0"
      y="0"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM6.924 9.076a.6.6 0 1 0-.848.848l5.5 5.5a.6.6 0 0 0 .848 0l5.5-5.5a.6.6 0 0 0-.848-.848L12 14.15z"
          clipRule="evenodd"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}
